import { consumeCodeOutput } from "./auth.types";

export type ConsumeOTPCodeError = Exclude<consumeCodeOutput["status"], "OK">;

export const CONSUME_OTP_CODE_ERRORS: Record<ConsumeOTPCodeError, string> = {
  INCORRECT_USER_INPUT_CODE_ERROR: "Incorrect code. Please try again.",
  EXPIRED_USER_INPUT_CODE_ERROR: "Code has expired. Please request a new one.",
  RESTART_FLOW_ERROR:
    "Something went wrong. Please start the authentication process from scratch.",
  SIGN_IN_UP_NOT_ALLOWED: "Sign in/up not allowed.",
} as const;
